import React, { useState, useEffect } from 'react';           // ← 加上 useEffect
import { useAuth } from '../contexts/AuthContext';
import { Form, Button, Container, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import api   from '../api';
import localBg from '../assets/bg.jpg';

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // 注册模态
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [regUsername, setRegUsername] = useState('');
  const [regPassword, setRegPassword] = useState('');

  /* ------------------------------------------------------------------
   * ★★★ 已登录用户访问 /login ➜ 直接跳转 /lobby ★★★
   * ----------------------------------------------------------------*/
  useEffect(() => {
    if (user) navigate('/lobby', { replace: true });
  }, [user, navigate]);

  // ====== 登录 ======
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(username, password);

    if (result.success) {
      toast.success('登录成功');
      if (result.user?.role === 'admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/lobby', { replace: true });
      }
    } else {
      toast.error(result.message || '登录失败');
    }
  };

  // ====== 注册 ======
  const handleOpenRegister  = () => { setRegUsername(''); setRegPassword(''); setShowRegisterModal(true); };
  const handleCloseRegister = () => setShowRegisterModal(false);

  const handleRegister = async () => {
    if (!regUsername || !regPassword) {
      toast.warning('请填写注册信息');
      return;
    }
    try {
      const res = await api.post('/api/users/register', {
        username: regUsername,
        password: regPassword,
      });
      toast.success(res.data.message || '注册成功');
      setShowRegisterModal(false);
      setUsername(regUsername);   // 自动填充到登录框
      setPassword(regPassword);
    } catch (err) {
      console.error('注册失败:', err);
      toast.error(err.response?.data?.message || '注册失败');
    }
  };

  // ====== 管理员登录入口 ======
  const handleGoAdminLogin = () => navigate('/adminlogin');

  return (
    <div
      style={{
        backgroundImage: `url(${localBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backgroundBlendMode: 'darken',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Container fluid="sm" style={{ maxWidth: '400px' }}>
        <h3 className="text-center mb-4 text-white" style={{ fontWeight: 'bold' }}>
          THE ONE 欢迎您！
        </h3>

        {/* 登录表单 */}
        <Form
          onSubmit={handleSubmit}
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            padding: '20px',
            borderRadius: '8px',
          }}
        >
          <Form.Group className="mb-3" controlId="loginUsername">
            <Form.Label>用户名</Form.Label>
            <Form.Control
              type="text"
              placeholder="请输入用户名"
              autoComplete="username"
              style={{ fontSize: '1.1rem', padding: '0.75rem' }}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="loginPassword">
            <Form.Label>密码</Form.Label>
            <Form.Control
              type="password"
              placeholder="请输入密码"
              autoComplete="current-password"
              style={{ fontSize: '1.1rem', padding: '0.75rem' }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 btn-lg">
            登录
          </Button>
        </Form>

        <div className="text-center mt-3">
          <Button variant="link" onClick={handleOpenRegister} className="text-white">
            没有账号？点此注册
          </Button>
        </div>

        {/* ========== 分割线 ========== */}
        <div className="text-center mt-2">
          <Button variant="outline-light" size="sm" onClick={handleGoAdminLogin}>
            管理员登录入口
          </Button>
        </div>
      </Container>

      {/* ========== 注册 Modal ========== */}
      <Modal show={showRegisterModal} onHide={handleCloseRegister}>
        <Modal.Header closeButton>
          <Modal.Title>注册新账号</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="regUsername" className="mb-3">
              <Form.Label>用户名</Form.Label>
              <Form.Control
                type="text"
                placeholder="输入用户名"
                value={regUsername}
                onChange={(e) => setRegUsername(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="regPassword" className="mb-3">
              <Form.Label>密码</Form.Label>
              <Form.Control
                type="password"
                placeholder="输入密码"
                value={regPassword}
                onChange={(e) => setRegPassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRegister}>
            取消
          </Button>
          <Button variant="primary" onClick={handleRegister}>
            注册
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Login;
